import { compact } from 'lodash'
import PositionRenderer from '../utilities/layouts/position_renderer';

export default class LayoutPosition {

  // eslint-disable-next-line max-params
  constructor(id, x, y, active, highlight, identifier, shape, inventory_unit_id, product_name, sectionIds) {
    this.id = id
    this.x = x;
    this.y = y;
    this.active = active;
    this.highlight = highlight;
    this.identifier = identifier;
    this.shape = shape;
    this.inventoryUnitId = inventory_unit_id;
    this.productName = product_name;
    this.sectionIds = compact([sectionIds].flat()); // wrap array & no falsey values
    this.sectionId = this.sectionIds[0] || null;
    this.key = `position-${this.id}`;
    this.booked = false;
  }

  static fromAttributes({ id, x, y, active, highlight, identifier, shape, inventory_unit_id, product_name, layout_section_memberships }) {
    const sectionIds = layout_section_memberships.map(membership => membership.layout_section_id)
    return new LayoutPosition(
      id,
      x,
      y,
      active,
      highlight,
      identifier,
      shape,
      inventory_unit_id,
      product_name,
      sectionIds,
    );
  }

  serialize() {
    return {
      id: this.id,
      x: this.x,
      y: this.y,
      active: this.active,
      highlight: this.highlight,
      identifier: this.identifier,
      shape: this.shape,
      inventory_unit_id: this.inventoryUnitId
    }
  }

  renderOn(canvas, readOnly = false) {
    this.renderer = new PositionRenderer(this, readOnly);
    this.renderer.setCanvas(canvas).render();
  }

  setBookedPosition(bookedPosition) {
    this.booked = bookedPosition;
  }

  setMoveState(state) {
    this.renderer.setMoveState(state);
  }

  setLabel(label) {
    this.identifier = label;
    this.renderer.reRender();
  }

  setHighlight(highlight) {
    this.highlight = highlight;
    this.renderer.reRender()
  }

  setActiveness(active) {
    this.active = active;
  }

  setActive() {
    this.renderer.setActive();
  }

  setFillColor(color) {
    this.renderer.setFillColor(color);
  }

  remove() {
    this.renderer.remove();
  }

  topRightX() {
    return this.x + 1;
  }

  bottomLeftY() {
    return this.y + 1;
  }
}
